import request from '@/utils/request'
const baseUrl = process.env.VUE_APP_COMMON_API
export function remainSendMsg(data) {
  return request({
    url: baseUrl + '/external/api/remain/sendMsg',
    method: 'POST',
    data
  })
}
export function remainAddTrack(data) {
  return request({
    url: baseUrl + '/external/api/remain/addTrack',
    method: 'POST',
    data
  })
}
export function remainVaildCode(data) {
  return request({
    url: baseUrl + '/external/api/remain/vaildCode',
    method: 'POST',
    data
  })
}
export function background(data) {
  return request({
    url: baseUrl + '/external/api/remain/background',
    method: 'POST',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/login.js